import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, Printer, IndianRupee, Home } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { PublicHeader, PublicFooter } from "@/components/PublicChrome";
import WhatsAppButton, { WhatsAppInfo } from "@/components/WhatsAppButton";

export default function SuccessPage() {
  const { appNo } = useParams();
  const [app, setApp] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/applications/${appNo}`).then((r) => setApp(r.data)).catch(() => setErr("Application not found"));
  }, [appNo]);

  return (
    <div className="min-h-screen bg-white">
      <div className="no-print"><PublicHeader/></div>
      <main className="max-w-3xl mx-auto px-6 py-12">
        {err ? (
          <div className="border border-red-200 bg-red-50 text-red-700 rounded-md p-6">{err}</div>
        ) : !app ? (
          <div className="text-zinc-500">Loading…</div>
        ) : (
          <div className="border border-zinc-200 rounded-lg p-10 bg-white" data-testid="success-panel">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center">
                <CheckCircle2 className="text-emerald-600" size={24} />
              </div>
              <div>
                <p className="tech-label text-emerald-700">Application Submitted</p>
                <h1 className="font-display text-3xl font-black tracking-tighter">Registration successful.</h1>
              </div>
            </div>
            <div className="mt-8 grid sm:grid-cols-2 gap-6 border-t border-zinc-100 pt-6">
              <div>
                <p className="tech-label">Application Number</p>
                <p className="mt-1 font-display text-2xl font-black tracking-tight" data-testid="success-app-no">{app.application_no}</p>
              </div>
              <div>
                <p className="tech-label">Name</p>
                <p className="mt-1 font-semibold">{app.full_name}</p>
              </div>
              <div>
                <p className="tech-label">Training Status</p>
                <p className="mt-1 font-semibold" data-testid="success-training-status">
                  {app.training_status === "with_training" ? "With Training" : "Without Training"}
                </p>
              </div>
              <div>
                <p className="tech-label">Fee</p>
                <p className="mt-1 font-display text-2xl font-black tracking-tight flex items-center" data-testid="success-fee">
                  <IndianRupee size={18} strokeWidth={3}/>{app.fee_amount?.toLocaleString("en-IN")}
                </p>
              </div>
              <div>
                <p className="tech-label">Status</p>
                <span className="mt-1 inline-block text-xs font-bold uppercase tracking-wider bg-amber-100 text-amber-700 rounded px-2 py-1">{app.status}</span>
              </div>
              <div>
                <p className="tech-label">Submitted</p>
                <p className="mt-1 text-sm">{new Date(app.created_at).toLocaleString("en-IN")}</p>
              </div>
            </div>
            <div className="mt-8 flex flex-wrap gap-3 no-print">
              <Button onClick={() => window.print()} data-testid="print-btn" className="bg-zinc-900 hover:bg-zinc-800 text-white h-11 px-5"><Printer size={16} className="mr-2"/>Print Receipt</Button>
              <Link to="/"><Button variant="outline" className="h-11 px-5" data-testid="home-btn"><Home size={16} className="mr-2"/>New Application</Button></Link>
            </div>
            <div className="mt-8 no-print"><WhatsAppInfo/></div>
          </div>
        )}
      </main>
      <div className="no-print"><PublicFooter/></div>
      <WhatsAppButton variant="floating"/>
    </div>
  );
}
